import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, TemplateRef } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NumpadService } from '../../../../../../lib/numpad/numpad.service';
import { InfoMessagesActions } from '../../../../info-messages/actions';
import { RemoveButtonStyle } from '../../../../picks/components/digital/pick-remove-button/remove-button-style';
import { InfoTrackingContext } from '../../../../tracking/models';
import LinearBetslipTrackingActions from '../../../../tracking/state/linear-tracking.actions';
import {
    ILinearComboBetContainerService,
    LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN,
    LinearComboBetContainerViewModel,
    SgpBadgeType,
} from '../../../services/linear/linear-combo-bet-container-service.interface';

@Component({
    selector: 'bs-linear-combo-bet-container',
    templateUrl: './linear-combo-bet-container.component.html',
    styleUrls: ['./linear-combo-bet-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NumpadService],
    standalone: false,
})
export default class LinearComboBetContainerComponent implements OnInit {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() picksTemplate: TemplateRef<any>;
    @Input() infoMessageTemplate: TemplateRef<any>;
    @Input() detailsTemplate?: TemplateRef<any>;
    @Input() removeButtonStyle: RemoveButtonStyle;

    viewModel$: Observable<LinearComboBetContainerViewModel | null>;

    private onePickSelected: string;
    private picksSelected: string;
    sgpBadgeTypeEnum = SgpBadgeType;

    constructor(
        @Inject(LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN) private containerService: ILinearComboBetContainerService,
        sitecore: Sitecore,
        private store: Store,
    ) {
        this.onePickSelected = sitecore.betslip.linear.OnePickSelected;
        this.picksSelected = sitecore.betslip.linear.PicksSelected;
    }

    ngOnInit(): void {
        this.viewModel$ = this.containerService.viewModel$;
    }

    readonly infoMessageId = 'linearComboBetInfo';
    expanded = this.containerService.isExpandedByDefault;

    toggleEachWay(event: boolean): void {
        this.containerService.toggleEachWay(event);
    }

    toggleExpand(): void {
        this.expanded = !this.expanded;

        this.containerService.toggleExpansion(this.expanded);
    }

    remove(): void {
        this.containerService.remove();
    }

    selectedPicksCountText(placeablePicksCount: number): string {
        return placeablePicksCount === 1 ? this.onePickSelected : interpolateDoubleBracesString(this.picksSelected, { count: placeablePicksCount });
    }

    toggleInfoMessage(event: Event, infoContext: InfoTrackingContext, slipId: string): void {
        event.stopPropagation();
        this.store.dispatch(InfoMessagesActions.toggle({ messageId: this.getInfoMessageId(slipId) }));
        this.store.dispatch(LinearBetslipTrackingActions.clickInfoIcon({ messageId: this.infoMessageId, infoContext }));
    }

    // Since this is being passed into templates, it needs to be an arrow function
    getCloseInfoMessageFunc = (slipId: string) => {
        return () => this.store.dispatch(InfoMessagesActions.closeById({ messageId: this.getInfoMessageId(slipId) }));
    };

    getInfoMessageId(slipId: string): string {
        return `${this.infoMessageId}-${slipId}`;
    }
}
